import { useAuthorization } from '@vacasa/react-components-lib';
import jwtDecode from 'jwt-decode';

export interface JwtPayload {
    email: string;
    sub: string;
}

export function useAuth() {
    const auth = useAuthorization();

    if (auth) {
        const jwt = jwtDecode<JwtPayload>(auth.idToken);
        return {
            sub: jwt.sub,
            email: jwt.email,
        };
    }

    if (Vacasa?.IdpUserID && Vacasa.IdpUserEmail) {
        return {
            sub: Vacasa.IdpUserID,
            email: Vacasa.IdpUserEmail,
        };
    }

    return undefined;
}
